// Config bridging the 12 markets to their SEO landing pages.
// The `key` values MUST stay in sync with backend `MARKET_KEYS`.
// The `urlPrefix` is the leading path segment (everything before `-result-today`,
// `-common-number`, `-previous-result`).

export const SEO_MARKETS = [
    {
        key: "shillong_morning",
        urlPrefix: "shillong-morning-teer",
        display: "Shillong Morning Teer",
        short: "Shillong Morning",
        location: "Shillong, Meghalaya",
        frTime: "10:30 AM",
        srTime: "11:30 AM",
        blurb:
            "Shillong Morning Teer is the earliest archery-based result of the day held at the Khasi Hills Archery Sports Institute in Shillong, Meghalaya. Two rounds are announced: First Round (F/R) at 10:30 AM and Second Round (S/R) at 11:30 AM IST.",
    },
    {
        key: "morning_teer",
        urlPrefix: "morning-sunday-teer",
        display: "Morning Sunday Teer",
        short: "Morning Sunday",
        location: "Meghalaya (Sunday & morning cycle)",
        frTime: "10:30 AM",
        srTime: "11:30 AM",
        blurb:
            "Morning Sunday Teer is the daily morning archery result popular on Sunday and morning cycles alongside the Shillong morning declaration. First Round is announced around 10:30 AM and Second Round around 11:30 AM IST.",
    },
    {
        key: "morning_teer_live",
        urlPrefix: "morning-teer-live",
        display: "Morning Teer Live",
        short: "Morning Live",
        location: "Meghalaya (Live morning coverage)",
        frTime: "10:30 AM",
        srTime: "11:30 AM",
        blurb:
            "Morning Teer Live provides the same 10:30 AM First Round and 11:30 AM Second Round declarations with live counter-side updates. Values are refreshed here the moment they are announced.",
    },
    {
        key: "bhutan_morning",
        urlPrefix: "bhutan-morning-teer",
        display: "Bhutan Morning Teer",
        short: "Bhutan Morning",
        location: "Bhutan Border Region",
        frTime: "10:30 AM",
        srTime: "11:30 AM",
        blurb:
            "Bhutan Morning Teer is the early archery result available across the Meghalaya-Bhutan border region. First Round is declared around 10:30 AM and Second Round around 11:30 AM IST.",
    },
    {
        key: "guwahati_morning",
        urlPrefix: "guwahati-morning-teer",
        display: "Guwahati Morning Teer",
        short: "Guwahati Morning",
        location: "Guwahati, Assam",
        frTime: "10:30 AM",
        srTime: "11:30 AM",
        blurb:
            "Guwahati Morning Teer is the Assam-based morning archery result declared in Guwahati. Two rounds are declared — F/R around 10:30 AM and S/R around 11:30 AM IST.",
    },
    {
        key: "juwai",
        urlPrefix: "juwai-teer",
        display: "Juwai Teer",
        short: "Juwai",
        location: "Jowai, Meghalaya",
        frTime: "02:45 PM",
        srTime: "03:25 PM",
        blurb:
            "Juwai Teer (Jowai Teer) is the afternoon archery result conducted in Jowai, the West Jaintia Hills district of Meghalaya. First Round is announced around 02:45 PM and Second Round around 03:25 PM IST.",
    },
    {
        key: "bhutan",
        urlPrefix: "bhutan-teer",
        display: "Bhutan Teer",
        short: "Bhutan",
        location: "Bhutan Border, Meghalaya",
        frTime: "04:00 PM",
        srTime: "05:00 PM",
        blurb:
            "Bhutan Teer is the mid-afternoon archery result available across the Meghalaya–Bhutan border region. First Round is declared around 04:00 PM and Second Round around 05:00 PM IST.",
    },
    {
        key: "shillong_teer",
        urlPrefix: "shillong-teer",
        display: "Shillong Teer",
        short: "Shillong",
        location: "Shillong, Meghalaya",
        frTime: "04:15 PM",
        srTime: "05:15 PM",
        blurb:
            "Shillong Teer is the most followed traditional archery-based result of Meghalaya, organised by the Khasi Hills Archery Sports Institute. First Round is declared around 04:15 PM and Second Round around 05:15 PM IST daily.",
    },
    {
        key: "khanapara",
        urlPrefix: "khanapara-teer",
        display: "Khanapara Teer",
        short: "Khanapara",
        location: "Khanapara, Guwahati (Assam)",
        frTime: "04:15 PM",
        srTime: "05:15 PM",
        blurb:
            "Khanapara Teer is the Assam-based archery result declared in Khanapara, Guwahati. Two rounds are declared each afternoon — F/R around 04:15 PM and S/R around 05:15 PM IST.",
    },
    {
        key: "my_night_teer",
        urlPrefix: "my-night-teer",
        display: "My Night Teer",
        short: "My Night",
        location: "Meghalaya (Evening)",
        frTime: "08:00 PM",
        srTime: "09:00 PM",
        blurb:
            "My Night Teer is one of the popular evening rounds. First Round is announced around 08:00 PM and Second Round around 09:00 PM IST.",
    },
    {
        key: "lucky_night",
        urlPrefix: "lucky-night-teer",
        display: "Lucky Night Teer",
        short: "Lucky Night",
        location: "Meghalaya (Late Evening)",
        frTime: "10:00 PM",
        srTime: "11:00 PM",
        blurb:
            "Lucky Night Teer is the late-evening archery result. First Round is declared around 10:00 PM and Second Round around 11:00 PM IST.",
    },
    {
        key: "night_teer",
        urlPrefix: "night-teer",
        display: "Night Teer",
        short: "Night",
        location: "Meghalaya (Night)",
        frTime: "11:25 PM",
        srTime: "12:25 AM",
        blurb:
            "Night Teer is the closing archery result of the day. First Round is declared around 11:25 PM and Second Round around 12:25 AM IST (next-day rollover).",
    },
];

export const SEO_MARKETS_BY_KEY = Object.fromEntries(
    SEO_MARKETS.map((m) => [m.key, m]),
);

// Path helpers — always append the specific page suffix to the market's URL prefix.
export const resultTodayPath = (prefix) => `/${prefix}-result-today`;
export const commonNumberPath = (prefix) => `/${prefix}-common-number`;
export const previousResultPath = (prefix) => `/${prefix}-previous-result`;

// Content builders — used by the 3 page components to guarantee UNIQUE per-game text.
export const buildResultTodayCopy = (m) => ({
    title: `${m.display} Result Today – Live FR & SR Result`,
    description: `Check today's ${m.display} Result with the latest FR (${m.frTime}) and SR (${m.srTime}) updates from ${m.location}. Live status, recent previous results and common number links.`,
    h1: `${m.display} Result Today`,
    keywords: `${m.display}, ${m.display} Result Today, ${m.short} Teer Result, ${m.display} FR SR, ${m.display} live result, ${m.display} today`,
    faq: [
        {
            q: `What time is ${m.display} result declared today?`,
            a: `${m.display} First Round (FR) is declared around ${m.frTime} IST and Second Round (SR) around ${m.srTime} IST every day.`,
        },
        {
            q: `Where is ${m.display} conducted?`,
            a: `${m.display} is conducted at ${m.location}. Results are announced live by the organising archery association after each round.`,
        },
        {
            q: `Is ${m.display} result updated live on this page?`,
            a: `Yes. As soon as the F/R or S/R numbers are declared, this page auto-refreshes and shows the latest ${m.display} result.`,
        },
        {
            q: `Where can I check ${m.display} previous results and common number?`,
            a: `You can view ${m.display} previous results and today's ${m.display} common number using the links right below the live result on this page.`,
        },
    ],
});

export const buildCommonNumberCopy = (m) => ({
    title: `${m.display} Common Number Today – FR & SR Information`,
    description: `View today's ${m.display} common number information — Direct, House and Ending updates for both First Round and Second Round.`,
    h1: `${m.display} Common Number Today`,
    keywords: `${m.display} Common Number, ${m.short} Teer Common Number, ${m.display} Direct Number, ${m.display} House Number, ${m.display} Ending Number`,
    faq: [
        {
            q: `What is a ${m.display} common number?`,
            a: `A ${m.display} common number is a daily informational shortlist of Direct, House and Ending numbers. It is provided for reference / entertainment only and is not a guarantee of any outcome.`,
        },
        {
            q: `When is the ${m.display} common number updated?`,
            a: `The ${m.display} common number resets automatically once every day just after the daily cycle starts (after 1:00 AM IST) and stays the same for all visitors through the whole day.`,
        },
        {
            q: `What is the difference between Direct, House and Ending?`,
            a: `Direct is a 2-digit shortlist, House refers to the tens digit and Ending refers to the units digit of a ${m.display} result.`,
        },
    ],
});

export const buildPreviousResultCopy = (m) => ({
    title: `${m.display} Previous Result – FR & SR History Archive`,
    description: `Browse ${m.display} previous result history — First Round (FR) and Second Round (SR) numbers from earlier dates in one archive.`,
    h1: `${m.display} Previous Results`,
    keywords: `${m.display} Previous Result, ${m.short} Teer History, ${m.display} old result, ${m.display} result chart`,
    faq: [
        {
            q: `How far back can I see ${m.display} previous results?`,
            a: `You can see every ${m.display} result that has been published through our admin panel since the site went live. Newest results appear first.`,
        },
        {
            q: `Are these ${m.display} results official?`,
            a: `Yes. Every ${m.display} result listed on this archive was manually entered by verified admins right after the round was declared.`,
        },
        {
            q: `Can I filter ${m.display} previous results by date?`,
            a: `Yes. Use the date picker at the top of the archive to jump to any specific ${m.display} result date.`,
        },
    ],
});
